export const mainFont = 'TakeawaySans';
export const mainFontSize = '14px';
export const mainFontLineHeight = '26px';
